import {customAxios} from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

/**
 * 당해 년도 공휴일
 * @param props.toDayYear : {nextYear: string, toDayYear: string}
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
const GetNowHolyDay = (props) => {
    // 공공데이터포털(한국천문연구원_특일 정보) 호출은 backend 에서 처리
    return customAxios.post(myIpAddress + '/date/nowHolyDay',
        {
            solYear: props.toDayYear
        });
}

export default GetNowHolyDay;
